module.exports = __webpack_public_path__ + "img/download.3d90cad3.gif";